export const testimonialsData = [
  {
    id: 1,
    src: require('assets/images/avatar-2.jpg'),
    title: 'Mark Hromm',
    paragraph:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione, delectus  quidem,',
    star: 4
  },
  {
    id: 2,
    src: require('assets/images/avatar-4.jpg'),
    title: 'Luise Sharra',
    paragraph:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione.',
    star: 5
  },
  {
    id: 3,
    src: require('assets/images/avatar-3.jpg'),
    title: 'Johna Shannon',
    paragraph:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione, magnam tenetur nesciunt.',
    star: 4
  }
];
